module.exports = __webpack_public_path__ + "img/flyer-icon-3.0d2908de.svg";